import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { YarnBall } from "@/components/yarn/YarnBall";
import AuthPage from "@/pages/AuthPage";
import VerifyPage from "@/pages/VerifyPage";
import LobbyPage from "@/pages/LobbyPage";
import RoomPage from "@/pages/RoomPage";
import CatClosetPage from "@/pages/CatClosetPage";
import StoriesPage from "@/pages/StoriesPage";
import StoryPage from "@/pages/StoryPage";
import whynotLogo from "@/assets/whynot-logo.png";

const NEXT_KEY = "yarn_next";

function Footer() {
  return (
    <footer className="flex justify-center py-6">
      <a href="https://wwwwhynot.com" target="_blank" rel="noopener noreferrer" aria-label="Why Not"
        className="inline-block transition-transform duration-200 hover:scale-110 hover:-rotate-6" data-testid="whynot-logo-link">
        <img src={whynotLogo} alt="Why Not" width="36" height="36" className="h-9 w-9 object-contain" data-testid="whynot-logo" />
      </a>
    </footer>
  );
}

function Loading() {
  return (
    <div className="flex-1 grid place-items-center" data-testid="app-loading">
      <YarnBall size={56} className="yarn-spin" />
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Loading />;
  if (!user) {
    sessionStorage.setItem(NEXT_KEY, location.pathname);
    return <Navigate to="/" replace />;
  }
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user) {
    const next = sessionStorage.getItem(NEXT_KEY);
    sessionStorage.removeItem(NEXT_KEY);
    return <Navigate to={next || "/lobby"} replace />;
  }
  return children;
}

function App() {
  return (
    <div className="yarn-app">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicOnly><AuthPage /></PublicOnly>} />
            <Route path="/verify" element={<PublicOnly><VerifyPage /></PublicOnly>} />
            <Route path="/lobby" element={<Protected><LobbyPage /></Protected>} />
            <Route path="/room/:code" element={<Protected><RoomPage /></Protected>} />
            <Route path="/cats" element={<Protected><CatClosetPage /></Protected>} />
            <Route path="/stories" element={<Protected><StoriesPage /></Protected>} />
            <Route path="/story/:id" element={<StoryPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Footer />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
